import styles from "./styles.scss";

import { FC } from "react";
import clsx from "clsx";
import { Approvals, ApprovalsActive } from "@/assets/icons";
import { InboxIconContainerProps } from "@/components/side-navigation/inbox-icons/types";

export const InboxIcon: FC<InboxIconContainerProps> = ({
  className,
  isActive,
}) => {
  const hasUnread = false;

  let ApprovalIcon;

  if (isActive) {
    // ApprovalIcon = isMobile ? ApprovalsMobileActive : ApprovalsActive;
    ApprovalIcon = ApprovalsActive;
  } else {
    // ApprovalIcon = isMobile ? ApprovalsMobile : Approvals;
    ApprovalIcon = Approvals;
  }

  return (
    <span
      className={clsx(
        className,
        isActive && styles.active,
        hasUnread && styles.unread,
      )}
    >
      <ApprovalIcon />
    </span>
  );
};
